import { api } from '@/api';
import type { UsersQueryParams, UsersResponse, InviteUserRequest } from '../types';

export async function fetchUsers(params: UsersQueryParams): Promise<UsersResponse> {
  const queryParams = new URLSearchParams();
  queryParams.set('page', params.page.toString());
  queryParams.set('pageSize', params.pageSize.toString());

  if (params.search) {
    queryParams.set('search', params.search);
  }
  if (params.sortBy) {
    queryParams.set('sortBy', params.sortBy);
  }
  if (params.sortOrder) {
    queryParams.set('sortOrder', params.sortOrder);
  }

  return api.get<UsersResponse>(`/v1/users?${queryParams.toString()}`);
}

export async function inviteUser(data: InviteUserRequest): Promise<void> {
  await api.post(`/v1/companies/${data.companyId}/users/invite`, {
    email: data.email,
  });
}

export async function deleteUsers(userIds: string[]): Promise<void> {
  await api.delete(`/v1/users`, { userIds });
}
